import Axios, { AxiosInstance, AxiosRequestConfig, AxiosRequestHeaders, AxiosResponse } from 'axios';
import { ChrAuthClient } from '@chr/common-web-ui-authentication/authClient';
import { addLoggingInterceptor } from '@chr/common-http-interceptors-axios';

class Api {
  private axiosInstance: AxiosInstance;

  init(baseURL: string, appConfig: AppConfig, authClient: ChrAuthClient) {
    const axiosInstance = Axios.create({ baseURL });

    if (appConfig.loggingServiceUrl && appConfig.loggingAppId) {
      // add logging interceptor to axios instance
      addLoggingInterceptor(axiosInstance);
    }

    // headers and authentication
    axiosInstance.interceptors.request.use(async (config) => {
      config.headers = config.headers || {} as AxiosRequestHeaders;
      if (!config.headers['Pragma']) {
        config.headers['Pragma'] = 'no-cache';
      }
      if (!config.headers['Cache-Control']) {
        config.headers['Cache-Control'] = 'no-cache';
      }
      if (!config.headers['Authorization']) {
        config.headers[
          'Authorization'
        ] = `Bearer ${await authClient.getAccessToken()}`;
      }
      return config;
    });

    this.axiosInstance = axiosInstance;
  }

  _replaceAxiosForUseWithTests = (axios: AxiosInstance) => {
    this.axiosInstance = axios;
  };

  get = <T = any, R = AxiosResponse<T>>(
    url: string,
    config?: AxiosRequestConfig
  ) => {
    return this.axiosInstance.get<T, R>(url, config);
  };

  delete = <T = any, R = AxiosResponse<T>>(
    url: string,
    config?: AxiosRequestConfig
  ) => {
    return this.axiosInstance.delete<T, R>(url, config);
  };

  post = <T = any, R = AxiosResponse<T>>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig
  ) => {
    return this.axiosInstance.post<T, R>(url, data, config);
  };

  put = <T = any, R = AxiosResponse<T>>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig
  ) => {
    return this.axiosInstance.put<T, R>(url, data, config);
  };
}

export const GatewayApi = new Api();
